// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => CompanyNameMatchingCompanyType.loadInternal(), entryList => {
        CompanyNameMatchingCompanyType.θentryList.set(entryList)
        CompanyNameMatchingCompanyType.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class CompanyNameMatchingCompanyType {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<CompanyNameMatchingCompanyType.Id | null>;
    static readonly Id = String;
    static ids: CompanyNameMatchingCompanyType.Id[] = [] as any;
    static idsAndDisplayValues: Record<CompanyNameMatchingCompanyType.Id, string> = {} as any;
    static θentryList = signal<CompanyNameMatchingCompanyType.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<CompanyNameMatchingCompanyType.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? CompanyNameMatchingCompanyType.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return CompanyNameMatchingCompanyType[BoInfoSymbol]
    }

    get __type(): 'Toolbox.CompanyNameMatchingCompanyType' {
        return 'Toolbox.CompanyNameMatchingCompanyType'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.CompanyNameMatchingCompanyType' {
        return 'Toolbox.CompanyNameMatchingCompanyType'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): CompanyNameMatchingCompanyType.Id | null {
        return this.θid()
    }

    set id(id: CompanyNameMatchingCompanyType.Id | CompanyNameMatchingCompanyType | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !CompanyNameMatchingCompanyType.getEntry(id as CompanyNameMatchingCompanyType.Id)) throw new Error('Invalid id for type Toolbox.CompanyNameMatchingCompanyType: ' + id)
        this.θid.set(id as CompanyNameMatchingCompanyType.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): CompanyNameMatchingCompanyType.Id[] {
        return CompanyNameMatchingCompanyType.ids
    }

    get idsAndDisplayValues(): Record<CompanyNameMatchingCompanyType.Id, string> {
        return CompanyNameMatchingCompanyType.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[CompanyNameMatchingCompanyType.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isAll() {
        return this.id == 'all'
    }

    static get All() {
        return new this('all')
    }

    get isParents() {
        return this.id == 'parents'
    }

    static get Parents() {
        return new this('parents')
    }

    get isChidren() {
        return this.id == 'chidren'
    }

    static get Chidren() {
        return new this('chidren')
    }

    constructor(idOrObject: CompanyNameMatchingCompanyType.Id | CompanyNameMatchingCompanyType | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): CompanyNameMatchingCompanyType.Entry[] {
        return This.CompanyNameMatchingCompanyType.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): CompanyNameMatchingCompanyType.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: CompanyNameMatchingCompanyType.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof CompanyNameMatchingCompanyType.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = CompanyNameMatchingCompanyType.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<CompanyNameMatchingCompanyType.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new CompanyNameMatchingCompanyType(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: CompanyNameMatchingCompanyType.Id | CompanyNameMatchingCompanyType | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as CompanyNameMatchingCompanyType.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: CompanyNameMatchingCompanyType.Id | CompanyNameMatchingCompanyType) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<CompanyNameMatchingCompanyType.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.CompanyNameMatchingCompanyType yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setAll() {
        this.id = 'all'

    }

    setParents() {
        this.id = 'parents'

    }

    setChidren() {
        this.id = 'chidren'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "all", label: "All companies" }),
            Object.freeze({ id: "parents", label: "Parent companies" }),
            Object.freeze({ id: "chidren", label: "Child companies" })
        ] as CompanyNameMatchingCompanyType.Entry[]) as CompanyNameMatchingCompanyType.Entry[]
    }
}
jsonClass('Toolbox.CompanyNameMatchingCompanyType')(CompanyNameMatchingCompanyType)

export const CompanyNameMatchingCompanyTypeθId = String;

export type CompanyNameMatchingCompanyTypeθId = string;

export namespace CompanyNameMatchingCompanyType {
    export type Id = 'all' | 'parents' | 'chidren'

    export interface Entry {
        id: CompanyNameMatchingCompanyType.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => CompanyNameMatchingCompanyType.load(true))
